module.exports = __webpack_public_path__ + "static/media/luxury-slider.6b34737e.png";